import { BrandFontRef } from 'modules/BrandDefinition';
import React from 'react';
import Font from 'components/Toolbar/Shared/Font';
import * as Models from 'models';
import styles from './styles.module.scss';

type Props = {
  activeFont: BrandFontRef | undefined;
  fonts: Models.BrandFontsList;
  title: string;
  toggleFontFamily(font: Models.BrandFontMap, charStyle: Models.CharacterStyleMap): void;
  dataTestId?: string;
};

const FontsCategory: React.FunctionComponent<Props> = (props) => {
  const {
    activeFont,
    toggleFontFamily,
    title,
    fonts,
    dataTestId = 'fontsCategory',
  } = props;

  return (
    <div className={styles.FontsCategory} data-testid={dataTestId}>
      <div className={styles.title} data-testid={`${dataTestId}-title`}>{title}</div>
      <div>
        {fonts.map((font: Models.BrandFontMap, index: number) => (
          <Font
            key={font.get('name')}
            activeFont={activeFont}
            font={font}
            fonts={fonts}
            toggleFontFamily={toggleFontFamily}
            dataTestId={`${dataTestId}-font${index}`}
          />
        ))}
      </div>
    </div>
  );
};

export default FontsCategory;
